exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-12-wrapper[data-v-576c889b]{width:235px;padding-bottom:10px}.listing-img[data-v-576c889b]{width:38px;height:38px;border-radius:50%;display:inline-block}", ""]);

// exports
